import { useProductFormSchema } from '../hooks'
import { ElementSectionForm } from './ElementSectionForm'
import type { ContractElement } from '../types'

function is404(err: unknown): boolean {
  return (err as { response?: { status?: number } } | null)?.response?.status === 404
}

/** Loads the element's product form schema and renders its sections, editing element.extras. */
export function ElementFieldsPanel({ contractId, element }: { contractId: number; element: ContractElement }) {
  const schemaQ = useProductFormSchema(element.productCode)

  if (schemaQ.isLoading) return <div className="text-xs text-slate-500 px-1 py-2">Ładowanie pól...</div>
  if (schemaQ.error && !is404(schemaQ.error)) {
    return <div className="text-xs text-red-600 px-1 py-2">Błąd ładowania pól.</div>
  }

  const schema = schemaQ.data
  const sections = schema?.sections ?? []
  if (!schema || sections.length === 0) {
    return (
      <div className="text-xs text-slate-400 italic px-1 py-2">
        Ten produkt nie ma jeszcze pól (zdefiniuj w Produkty → Sekcje formularza).
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-3 mt-3">
      {sections.map(s => (
        <ElementSectionForm
          key={s.id}
          contractId={contractId}
          elementId={element.id}
          extras={element.extras}
          schema={schema}
          section={s}
        />
      ))}
    </div>
  )
}
